<div class="spinner-container">
    <clare-spinner *letVar="redirect$ | async" [text]="'Loading Account'"></clare-spinner>
</div>
